<template>
  <div class="chart-root">
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
import ChartJs from 'chart.js'

export default {
  name: 'BarChart',
  props: {
    chartData: { type: Object, required: true },
    options: { type: Object, required: true }
  },
  data() {
    return {
      chart: null
    }
  },
  mounted() {
    this.render()
  },
  watch: {
    chartData: {
      deep: true,
      handler() {
        this.render()
      }
    },
    options: {
      deep: true,
      handler() {
        this.render()
      }
    }
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  },
  methods: {
    render() {
      if (!this.$refs.canvas) return

      if (this.chart) {
        this.chart.destroy()
        this.chart = null
      }

      const ctx = this.$refs.canvas.getContext('2d')

      // Ensure responsive fill of parent height
      const mergedOptions = Object.assign({}, this.options || {}, {
        responsive: true,
        maintainAspectRatio: false
      })

      this.chart = new ChartJs(ctx, {
        type: 'bar',
        data: this.chartData,
        options: mergedOptions
      })
    }
  }
}
</script>

<style scoped>
.chart-root {
  height: 100%;
  width: 100%;
}

.chart-root canvas {
  display: block;
  height: 100% !important;
  width: 100% !important;
}
</style>